<template>
	<div class="animate_animated animate__slideInRight">
		<div class="fixed w-full top-0 left-0 z-20">
			<div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
        <div class="h-1 bg-gradient-to-r from-amber-500 to-amber-200"></div>
				<div class="flex items-center px-4 py-4">
					<div class="flex items-center w-full">
						<a @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
						<span class="text-base text-content font-medium ml-4">Edit Enquiry</span>
					</div>
				</div>
			</div>
		</div>
		<div class="pt-20 bg-white mt-2">
			<div class="bg-white min-h-screen p-4">
				<Enquiry :enquiry="EditEnquiry"/>
				<div class="mb-6 relative">
					<div v-if="DynamicForm == true">
            <div class="mb-6 relative">
              <div v-for="field in dynamicFields" :key="field.name" class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  {{ field.pretty_name }}
                  <span v-if="field.is_required" class="text-red-500">*</span>
                </label>
                <!-- SELECT -->
                <select
                  v-if="field.datatype === 'string' && field.is_select_list"
                  v-model="magicFields[field.name]"
                  class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none"
                >
                  <option value="">Select</option>
                  <option
                    v-for="item in field.items"
                    :key="itemKey(item)"
                    :value="String(itemValue(item))"
                  >
                    {{ itemLabel(item) }}
                  </option>
                </select>
                <!-- TEXT -->
                <input
                  v-else-if="field.datatype === 'string'"
                  type="text"
                  v-model="magicFields[field.name]"
                  class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none"
                />
                <!-- NUMBER -->
                <input
                  v-else-if="field.datatype === 'integer'"
                  type="number"
                  v-model.number="magicFields[field.name]"
                  class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none"
                />
                <!-- DATE -->
                <input
                  v-else-if="field.datatype === 'date'"
                  type="date"
                  v-model="magicFields[field.name]"
                  class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none"
                />
                <!-- DATETIME -->
                <input
                  v-else-if="field.datatype === 'datetime'"
                  type="datetime-local"
                  v-model="magicFields[field.name]"
                  class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none"
                />
                <!-- CHECKBOX -->
                <input
                  v-else-if="field.datatype === 'check_box_boolean'"
                  type="checkbox"
                  v-model="magicFields[field.name]"
                  class="h-4 w-4"
                />
                <!-- Fallback: simple text -->
                <input
                  v-else
                  type="text"
                  v-model="magicFields[field.name]"
                  class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none"
                />
              </div>
            </div>
          </div>
				</div>
				<div class="mt-10">
					<button type="button" @click="updateEnquiry"
						class="bg-primary text-base font-semibold text-white rounded-xl p-5 w-full disabled:opacity-50">
						Submit
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {prepareNextEnquiryParams} from '@/assets/scripts/utility.js';
import Enquiry from '@/components/Enquiry/Next.vue';
export default {
  components: {
    Enquiry
  },
  data () {
    return {
      dynamicFields: [],
      magicFields: {},
      DynamicForm: false,
      EditEnquiry: {},
      _loadedValues: [],
    }
  },
  created() {
    this.$axios.get(`mobile_crm/leads/${this.$route.params.uuid}`)
      .then((res) => {
        this.EditEnquiry = res.data.lead
        this._loadedValues = res.data.lead.magic_field_values || []
        // Also fetch field definitions so we have items/options for selects
        this.$axios.get(`mobile_crm/leads/magic_fields`)
          .then((defsRes) => {
            const defs = defsRes.data.magic_fields || []
            this.buildDynamicFields(defs, this._loadedValues)
          })
          .catch((err) => console.log(err));
      })
    .catch((err) => console.log(err));
    },
  methods: {
    coerceBoolean(value) {
      const trueValues = [true, 'true', 't', '1', 1, 'yes', 'on', 'y']
      const falseValues = [false, 'false', 'f', '0', 0, 'no', 'off', 'n', null, undefined, '']
      if (trueValues.includes(value)) return true
      if (falseValues.includes(value)) return false
      // fallback: try to JSON parse
      try {
        const parsed = typeof value === 'string' ? JSON.parse(value.toLowerCase()) : value
        return !!parsed
      } catch (e) {
        return !!value
      }
    },
    formatDate(value) {
      if (!value) return null
      const d = new Date(value)
      if (isNaN(d.getTime())) return null
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    formatDateTimeLocal(value) {
      if (!value) return null
      const d = new Date(value)
      if (isNaN(d.getTime())) return null
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      const hh = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}T${hh}:${min}`
    },
    normalizeValueForField(field, rawValue) {
      switch (field.datatype) {
        case 'check_box_boolean':
          return this.coerceBoolean(rawValue)
        case 'integer':
          if (rawValue === null || rawValue === undefined || rawValue === '') return null
          return Number(rawValue)
        case 'date':
          return this.formatDate(rawValue)
        case 'datetime':
          return this.formatDateTimeLocal(rawValue)
        default:
          // string or others
          if (field.is_select_list) {
            return rawValue === null || rawValue === undefined ? '' : String(rawValue)
          }
          return rawValue === undefined ? null : rawValue
      }
    },
    buildDynamicFields(definitions, values) {
      // definitions from /mobile_crm/leads/magic_fields
      // values from lead.magic_field_values
      const valueByKey = {}
      ;(Array.isArray(values) ? values : []).forEach(v => {
        valueByKey[v.key] = v.value
      })
      this.dynamicFields = (Array.isArray(definitions) ? definitions : []).map((d) => ({
        name: d.name,
        pretty_name: d.pretty_name,
        datatype: d.datatype,
        is_select_list: !!d.is_select_list,
        items: d.items || [],
        is_required: !!d.is_required
      }))
      this.dynamicFields.forEach((field) => {
        const existing = valueByKey[field.name]
        let normalized = this.normalizeValueForField(field, existing)
        // For select lists, coerce to string so it matches option values
        if (field.is_select_list) {
          normalized = normalized == null ? '' : String(normalized)
          // If normalized value is not in items, inject it so it can render as selected
          const valuesSet = new Set((field.items || []).map((it) => String(this.itemValue(it))))
          if (normalized !== '' && !valuesSet.has(normalized)) {
            // Preserve shape: if list is of objects, insert an object; otherwise insert primitive
            const isObjectList = Array.isArray(field.items) && field.items.some((it) => it && typeof it === 'object')
            if (isObjectList) {
              field.items = [{ value: normalized, label: normalized }, ...field.items]
            } else {
              field.items = [normalized, ...field.items]
            }
          }
        }
        this.magicFields[field.name] = normalized
      })
      this.DynamicForm = true
    },
    // Helpers to support both primitive and object items
    itemValue(item) {
      if (item && typeof item === 'object') {
        return item.value ?? item.id ?? item.key ?? item.code ?? item.name ?? item.text ?? item.label ?? ''
      }
      return item
    },
    itemLabel(item) {
      if (item && typeof item === 'object') {
        return item.label ?? item.text ?? item.name ?? String(this.itemValue(item))
      }
      return item
    },
    itemKey(item) {
      const val = this.itemValue(item)
      return typeof val === 'object' ? JSON.stringify(val) : String(val)
    },
    updateEnquiry() {
      let finalSubmitData = this.$store.getters.newEnquiryData
      let  nextParams = prepareNextEnquiryParams(this.EditEnquiry)
      let leadData = {...finalSubmitData, ...nextParams,  ...this.magicFields}
      this.$axios
        .put(`mobile_crm/leads/${this.$route.params.uuid}`, { lead: leadData })
        .then(res => {
          this.$swal.fire({
            title: "Enquiry Updated!",
            icon: "success"
          }).then(this.$router.replace({ name: "Enquiry" }));
          this.$store.dispatch('setnewEnquiryData', null);
        })
        .catch(err => {
          if (err.response.status === 500) {
            this.$swal.fire({
              title: "Server Error!",
              icon: "error"
            });
          } else {
            this.$swal.fire({
              title: "Error",
              text: err.response.data.message,
              icon: "error"
            });
          }
        });
    },
  },
  computed: {
    leadKeysList(){
      return this.$store.getters.leadKeys;
    },
  }
}
</script>
<style scoped>

</style>